import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '@services/user.service';
import { BaseComponent } from '../base/base/base.component';
import { models } from 'powerbi-client';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { IReportEmbedConfiguration } from 'embed';

import { environment } from '@environment';
import { User } from '@models/user';
import { UserEditComponent, UserEditData } from '../user-edit/user-edit.component';
import { Breadcrumb } from '@models/breadcrumb';
import { UserMaintenanceInfo } from '@models/user-maintenance-info';
import { LanguageSyncService } from '@services/language-sync.service';
import { Language } from '@models/language';
import { ReportService } from '@services/report.service';
import { AccountService } from '@services/account.service';

@Component({
    selector: 'cp-user-maintenance',
    templateUrl: './user-maintenance.component.html',
    styleUrls: ['./user-maintenance.component.less'],
    standalone: false
})
export class UserMaintenanceComponent extends BaseComponent implements OnInit {
    dataSource: MatTableDataSource<User>;
    searchTerm: string = '';
    noResultsFound: boolean = false;

    selectedUserId: string = '';

    displayColumns: string[] = [
        'userId', 'firstName', 'lastName', 'company', 'role', 'enabled'
    ];

    breadcrumbs: Breadcrumb[] =
        [
            { label: 'Home', route: '/home' },
            { label: 'Users', route: '' }
        ];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    userList: User[];

    canEditAdminUsers: boolean = false;

    userMaintenanceInfo: UserMaintenanceInfo;

    public reportConfig: IReportEmbedConfiguration = {
        type: 'report',
        embedUrl: undefined,
        id: undefined,
        tokenType: models.TokenType.Embed,
        accessToken: undefined,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false
                },
            },
            background: models.BackgroundType.Transparent,
        }
    };

    powerBiClass = 'report-container';

    powerBIPhasedEmbedding = false;

    powerBiEventHandlers = new Map([
        ['loaded', () => console.log('Report loaded')],
        ['rendered', () => console.log('Report rendered')],
        ['error', (event) => console.log('Report error:' + event.detail)]
    ]);

    reportReady: boolean = false;

    // powerBiEmbedConfig: IReportEmbedConfiguration = {
    //     type: 'report',   // Supported types: report, dashboard, tile, visual and qna
    //     id: '1c0dff5d-3c41-4a7d-bf59-17f8b791226c',
    //     embedUrl: "https://app.powerbi.com/reportEmbed?reportId=1c0dff5d-3c41-4a7d-bf59-17f8b791226c&autoAuth=true&ctid=f26fca78-727b-4da5-9639-d5f6f848ff26",
    //     accessToken: "<Access Token>",
    //     tokenType: models.TokenType.Embed,
    //     settings: {
    //         panes: {
    //             filters: {
    //                 expanded: false,
    //                 visible: false
    //             }
    //         },
    //         background: models.BackgroundType.Transparent,
    //     }
    // };
    // powerBiReportClass = 'report-container';
    // powerBiPhasedEmbedding = false;
    // powerBiEventHandlers = new Map([
    //     ['loaded', () => console.log('Report loaded')],
    //     ['rendered', () => console.log('Report rendered')],
    //     ['error', (event) => console.log(event.detail)]
    // ]);

    get isBMSTestEnv(): boolean {
        return environment.System === 'BMS' && !environment.production;
    }

    constructor(
        private _userService: UserService,
        private _dialog: MatDialog,
        private _languageSyncService: LanguageSyncService,
        private _reportService: ReportService,
        private _accountService: AccountService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.getUsers('');
        await this.initialize();

        this._languageSyncService.getLanguage().subscribe(
            (_: Language) => this.initialize()
        );

        this.canEditAdminUsers = await this._userService.canEdit('adminusers');
    }

    async initialize(): Promise<void> {
        this._userService.getUserMaintenanceInfo().subscribe((u: UserMaintenanceInfo) => {
            this.userMaintenanceInfo = u;
        });

        // let reportAccess: ReportAccess =
        //     await firstValueFrom(this._reportService.getReportAccess('1c0dff5d-3c41-4a7d-bf59-17f8b791226c')).then();

        // this.reportConfig.embedUrl = reportAccess.Url;
        // this.reportConfig.accessToken = reportAccess.Token;
        // this.reportConfig.id = '1c0dff5d-3c41-4a7d-bf59-17f8b791226c';
        // if (this._userService.getCustomerAccount()) {
        //     this.reportConfig.filters = [{
        //         filterType: models.FilterType.Basic,
        //         $schema: "http://powerbi.com/product/schema#basic", // Filter schema
        //         target: {
        //             table: "Customers",
        //             column: "accountnum"
        //         },
        //         operator: "In", // Filter operator
        //         values: [this._userService.getCustomerAccount().Id] // Values to filter by
        //     }];
        // }

        // this.reportReady = true;
    }

    isEditable(user: User): boolean {
        return  (user.Role ==='Partner') || (this.canEditAdminUsers);
    }

    private getUsers(searchCriteria: string): void {
        this._userService.getUsers(searchCriteria).subscribe({
            next: (results: User[]) => {
                if (!results || results.length === 0) {
                    this.noResultsFound = true;
                    this.userList = [];
                    this.dataSource = new MatTableDataSource(this.userList);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.paginator.length = 0;
                    return;
                }
                this.userList = results;
                this.dataSource = new MatTableDataSource(this.userList);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.paginator.length = results.length;
            },
            error: (e) => {
                this.noResultsFound = true;
                this.userList = [];
                this.dataSource = new MatTableDataSource(this.userList);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.paginator.length = 0;
        }
        });
    }

    selectUser(user: User): void {
        this.selectedUserId = user.Id;
    }

    addUser(): void {
        let userData: UserEditData = {
            user: null,
            action: 'Add',
            accounts: null
        };

        const addDialogRef: MatDialogRef<UserEditComponent> =
            this._dialog.open(UserEditComponent, { data: userData, width: '500px' });

        addDialogRef.afterClosed().subscribe({ next: () => this.getUsers('') });
    }

    async edituser(user: User, event: MouseEvent): Promise<void> {
        event.stopPropagation();

        if (!this.isEditable(user)) {
            return;
        }

        var accountList = await firstValueFrom(this._userService.getAccountsForUser('', user.Id));
        let userData: UserEditData = {
            user: user,
            action: 'Edit',
            accounts: accountList
        };

        const editDialogRef: MatDialogRef<UserEditComponent> =
            this._dialog.open(UserEditComponent, { data: userData, width: '500px' });

        editDialogRef.afterClosed().subscribe({ next: () => this.getUsers('') });
    }

    onSearch(): void {
        this.noResultsFound = false;
        this.getUsers(this.searchTerm);
    }

}
